import { render, staticRenderFns } from "./QBResult.vue?vue&type=template&id=a3c99822&"
import script from "./QBResult.vue?vue&type=script&lang=js&"
export * from "./QBResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/landun/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3c99822')) {
      api.createRecord('a3c99822', component.options)
    } else {
      api.reload('a3c99822', component.options)
    }
    module.hot.accept("./QBResult.vue?vue&type=template&id=a3c99822&", function () {
      api.rerender('a3c99822', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/page/search/components/QBResult.vue"
export default component.exports